import React from 'react';
import './B2.css';

const B2: React.FC = () => {
  const cards = [
    { title: 'Fluency Practice', subtitle: 'Speak confidently', badge: 'B2', bg: '#5EEAD4' },
    { title: 'Discussions', subtitle: 'Debate & reason', badge: 'B2', bg: '#3B82F6' },
    { title: 'Advanced Grammar', subtitle: 'Precision in form', badge: 'B2', bg: '#EF4444' },
    { title: 'Stories', subtitle: 'Comprehension focus', badge: 'B2', bg: '#9333EA' },
  ];

  return (
    <div className="level-wrapper">
      <h1 className="level-title">B2 - Upper Intermediate</h1>
      <div className="level-grid">
        {cards.map((card, index) => (
          <div key={index} className="level-card" style={{ backgroundColor: card.bg }}>
            <div className="level-badge">{card.badge}</div>
            <div className="level-content">
              <h2>{card.title}</h2>
              <p>{card.subtitle}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default B2;
